import { render, staticRenderFns } from "./AccreditationControl.vue?vue&type=template&id=0f213e70"
import script from "./AccreditationControl.vue?vue&type=script&lang=js"
export * from "./AccreditationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports